import { createAction, props } from '@ngrx/store';
import { LiveKitModels } from '@models/livekit.model';

export const resetToInitialState = createAction('[LIVE-KIT] Reset to Initial state');

export const getLiveKitRoomList = createAction('[LIVE-KIT] Get live kit room list');
export const getLiveKitRoomListSuccess = createAction('[LIVE-KIT] Get live kit room list success', props<{
  servers: LiveKitModels.Server[],
  summary: LiveKitModels.Summary,
}>());
export const getLiveKitRoomListFail = createAction('[LIVE-KIT] Get live kit room list fail');

export const removeLiveKit = createAction('[LIVE-KIT] Remove live kit', props<{
  room: LiveKitModels.ServerRoom,
  server: LiveKitModels.Server
}>());
export const removeLiveKitSuccess = createAction('[LIVE-KIT] Remove live kit success', props<{ server: LiveKitModels.Server }>());
export const removeLiveKitFail = createAction('[LIVE-KIT]Remove live kit fail');

export const setInitialLoader = createAction('[LIVE-KIT] Set initial loader', props<{
  loading: boolean
}>());